import { DEFAULT_OFFSET, FLOATING_POPOVER_VARIANTS } from "./constants";

export const getPopperContainer = () =>
  typeof document !== "undefined" ? document.body : null;

export const buildPopperConfig = (
  offsetPx = DEFAULT_OFFSET,
  { preventFlip = false } = {}
) => ({
  modifiers: [
    {
      name: "offset",
      options: { offset: [0, offsetPx] },
    },
    {
      name: "preventOverflow",
      options: { boundary: "viewport", padding: 12 },
    },
    {
      name: "flip",
      enabled: !preventFlip,
      options: { padding: 12 },
    },
    {
      name: "computeStyles",
      options: { gpuAcceleration: false },
    },
  ],
});

export const getVariantStyles = (variant) =>
  FLOATING_POPOVER_VARIANTS[variant] || FLOATING_POPOVER_VARIANTS.default;

export const getVariantClassName = (variant) =>
  `floating-popover floating-popover--${variant}`;
